import React from 'react'
import cx from 'classnames'

interface TableCellProps {
  children: React.ReactNode
  align?: 'left' | 'center' | 'right'
  className?: string
  colSpan?: number
  isEditing?: boolean
}

const TableCell = ({
  children,
  align = 'left',
  className,
  colSpan,
  isEditing = false,
}: TableCellProps) => {
  return (
    <td
      className={cx('table-cell', align, className, {
        'is-editing': isEditing,
      })}
      colSpan={colSpan}
    >
      {children}
    </td>
  )
}

export default TableCell
